import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { ServiceConfig } from "../../service/Config";
import i18n from "../../i18n";

export default function ServicoOnDemand({ configs, setConfigs }) {
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    useEffect(() => {
        carregarConfigs();
    }, []);

    const carregarConfigs = async () => {
        setLoading(true);

        try {
            const serviceConfig = new ServiceConfig();
            const response = await serviceConfig.listarServicosOnDemandPortal();
            setConfigs(Array.isArray(response) ? response : []);
        } catch (err) {
            console.error(err);
            setConfigs([]);
        } finally {
            setLoading(false);
        }
    };

    const atualizarUrl = (value, rowData) => {
        setConfigs(prev =>
            prev.map(c => (c.Id === rowData.Id ? { ...c, ServicoOnDemandPortal: value } : c))
        );
    };

    const urlEditor = (rowData) => (
        <InputText
            value={rowData.ServicoOnDemandPortal ?? ''}
            onChange={(e) => atualizarUrl(e.target.value, rowData)}
            className="service-OnDemand--DataTable-editor"
        />
    );

    return (
        <div className="service-OnDemand">
            <Toast ref={toast} />
            <DataTable
                className="dt-ondemand"
                value={configs}
                loading={loading}
                dataKey="Id"
                emptyMessage={i18n.t("PORTAL.COMPONENT.NO_UNIT_FOUND")}
                responsiveLayout="scroll"
                scrollable
                scrollHeight="250px"
            >
                <Column field="CodigoHIS" header={i18n.t("PORTAL.COMPONENT.UNIT")} style={{ width: '30%' }} />
                <Column header={i18n.t("PORTAL.COMPONENT.LINK")} body={urlEditor} style={{ width: '70%' }} />
            </DataTable>
        </div>
    );
}
